import { z } from "zod";
import {
  callEndToolPatchPayloadSchema,
  callEndToolPostPayloadSchema,
  callEndToolSettingsSchema,
  CallEndToolType
} from "./tools/callEnd.js";
import {
  callTransferToolPatchPayloadSchema,
  callTransferToolPostPayloadSchema,
  callTransferToolSettingsSchema,
  CallTransferToolType
} from "./tools/callTransfer.js";
import {
  codeToolPatchPayloadSchema,
  codeToolPostPayloadSchema,
  codeToolSettingsSchema,
  CodeToolType
} from "./tools/code.js";
import {
  customToolPatchPayloadSchema,
  customToolPostPayloadSchema,
  customToolSettingsSchema,
  CustomToolType
} from "./tools/custom.js";
import {
  webDocumentResearchToolPatchPayloadSchema,
  webDocumentResearchToolPostPayloadSchema,
  webDocumentResearchToolSettingsSchema,
  WebDocumentResearchToolType
} from "./tools/webDocumentResearch.js";
const ToolType = {
  CALL_TRANSFER: CallTransferToolType,
  CALL_END: CallEndToolType,
  CUSTOM: CustomToolType,
  CODE: CodeToolType,
  WEB_DOCUMENT_RESEARCH: WebDocumentResearchToolType
};
const allToolTypes = [
  ToolType.CALL_TRANSFER,
  ToolType.CALL_END,
  ToolType.CUSTOM,
  ToolType.CODE,
  ToolType.WEB_DOCUMENT_RESEARCH
];
function checkIsToolType(value) {
  return allToolTypes.some((toolType) => value === toolType);
}
const allToolSettingsSchemas = {
  [ToolType.CALL_TRANSFER]: callTransferToolSettingsSchema,
  [ToolType.CALL_END]: callEndToolSettingsSchema,
  [ToolType.CUSTOM]: customToolSettingsSchema,
  [ToolType.CODE]: codeToolSettingsSchema,
  [ToolType.WEB_DOCUMENT_RESEARCH]: webDocumentResearchToolSettingsSchema
};
function safeParseToolSettings(type, data) {
  return allToolSettingsSchemas[type].safeParse(data);
}
const toolPostPayloadSchema = z.discriminatedUnion("type", [
  callTransferToolPostPayloadSchema,
  callEndToolPostPayloadSchema,
  customToolPostPayloadSchema,
  codeToolPostPayloadSchema,
  webDocumentResearchToolPostPayloadSchema
]);
const toolPatchPayloadSchema = z.discriminatedUnion("type", [
  callTransferToolPatchPayloadSchema,
  callEndToolPatchPayloadSchema,
  customToolPatchPayloadSchema,
  codeToolPatchPayloadSchema,
  webDocumentResearchToolPatchPayloadSchema
]);
function getCustomToolMock(tool) {
  if (tool.type !== ToolType.CUSTOM && tool.type !== ToolType.CODE) {
    return void 0;
  }
  return tool.settings.mock;
}
export {
  ToolType,
  checkIsToolType,
  getCustomToolMock,
  safeParseToolSettings,
  toolPatchPayloadSchema,
  toolPostPayloadSchema
};
//# sourceMappingURL=tool.js.map
